export default function isDateValid(date) {
  return !isNaN(new Date(date));
}
